(function () {
  if (window.__ampSlidecartSubtotalInitialized) return;
  window.__ampSlidecartSubtotalInitialized = true;

  var SHIPPING_PROTECTION_TYPE = 'Slidecart - Shipping Protection';

  function formatMoney(cents, currency) {
    try {
      var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return String(cents / 100);
    }
  }

  function getVisibleItemsSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      if (item.product_type === SHIPPING_PROTECTION_TYPE) return sum;

      var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      return sum + (Number(linePrice) || 0);
    }, 0);
  }

  function getVisibleCompareAtSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      if (item.product_type === SHIPPING_PROTECTION_TYPE) return sum;
      return sum + (Number(item.original_line_price) || Number(item.line_price) || 0);
    }, 0);
  }

  function getDisplaySubtotalCents(cart, state) {
    var itemsSubtotal = getVisibleItemsSubtotal(cart);
    var cartTotal = Number(cart.total_price) || 0;
    var displayCents = cartTotal > itemsSubtotal ? itemsSubtotal : cartTotal;

    var discountCodeAmount = Number(state && state.discountCodeAmount) || 0;
    if (discountCodeAmount > 0 && !(Number(cart.total_discount) > 0)) {
      displayCents = Math.max(0, displayCents - discountCodeAmount);
    }

    return displayCents;
  }

  var isUpdatingSubtotal = false;

  function updateSubtotal() {
    if (isUpdatingSubtotal) return;
    if (typeof window.SLIDECART_STATE !== 'function') return;

    var state;
    try {
      state = window.SLIDECART_STATE();
    } catch (e) {
      return;
    }

    var cart = state && state.cart;
    if (!cart) return;

    var subtotalEl = document.querySelector('#slidecarthq .slidecart-subtotal');
    if (!subtotalEl) return;

    var displayCents = getDisplaySubtotalCents(cart, state);
    if (!displayCents && !cart.item_count) return;

    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cart.currency;
    var formatted = formatMoney(displayCents, currency);

    if (subtotalEl.innerHTML === formatted) return;

    isUpdatingSubtotal = true;
    subtotalEl.innerHTML = formatted;

    var compareAtCents = getVisibleCompareAtSubtotal(cart);
    var compareEl = document.querySelector('#slidecarthq .footer-subtotal-prices .price.strike-through');
    if (compareEl && compareAtCents > displayCents) {
      compareEl.innerHTML = formatMoney(compareAtCents, currency);
    }

    isUpdatingSubtotal = false;
  }

  var subtotalUpdateTimer;

  function scheduleUpdate() {
    window.clearTimeout(subtotalUpdateTimer);
    subtotalUpdateTimer = window.setTimeout(updateSubtotal, 0);
  }

  function observeSlideCart() {
    var root = document.getElementById('slidecarthq');
    if (!root || root.__ampSubtotalObserver) return;

    root.__ampSubtotalObserver = new MutationObserver(function () {
      if (isUpdatingSubtotal) return;
      scheduleUpdate();
    });

    root.__ampSubtotalObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function chainCallback(name, fn) {
    var previous = window[name];
    window[name] = function () {
      if (typeof previous === 'function') previous.apply(this, arguments);
      fn.apply(this, arguments);
    };
  }

  chainCallback('SLIDECART_LOADED', function () {
    scheduleUpdate();
    observeSlideCart();
  });
  chainCallback('SLIDECART_UPDATED', scheduleUpdate);
  chainCallback('SLIDECART_OPENED', scheduleUpdate);
})();
